import React from 'react'
import { bindActionCreators } from "redux";
import * as Actions from "../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import Grid from '@material-ui/core/Grid';
import { Paper } from "@material-ui/core";
import strings from "../../localization";
import Validators from "../../constants/ValidatorTypes";
import FormComponent from "../../common/FormComponent";
import { withSnackbar } from "notistack";
import { addRolePermissions } from '../../services/rolePermission/RolePermissionsService';
import RolePermissionForm from '../../components/forms/rolePermission/RolePermissionForm';
import { getRoleByName, getRoles } from '../../services/roles/RolesService';
import { getPermissionByName } from '../../services/permissions/PermissionService';

class AddRolePermissions extends FormComponent{

    validationList = {
        role: [{ type: Validators.REQUIRED }],
        permission: [{ type: Validators.REQUIRED }]
    };

    constructor(props) {
        super(props);

        this.state = {
            data: props.data ? props.data : {},
            errors: {}
        };

        this.props.changeFullScreen(false);

        this.submit = this.submit.bind(this);

    }

    onAutocompleteChange = (event, values) => {
        let autocompleteName = event.target.id.split("-")[0];
        this.setState({
            data: {
                ...this.state.data, [autocompleteName]: values
            }
        });
    }

    handleTextInputChange = (e) =>{
        if(e.target.name === "role" && e.target.value.trim().length >= 2){
            let data = {
                searchParam: e.target.value,
                companyId: this.props.cid,
                sort: "name,ASC",
                userId: 0,
            };
            {
                this.props.cid != undefined &&
                getRoles(data).then(response => {
                    if (!response.ok) {

                        return;
                    }

                    this.setState({
                        roles: response.data.entities,
                    });
                });
            }
        }

        if(e.target.name === "permission" && e.target.value.trim().length >= 2){
            let data = {
                searchParam: e.target.value,
                companyId: this.props.cid,
                sort: "category,ASC",
                userId: 0,
            };
            {
                this.props.cid != undefined &&
                getPermissionByName(data).then(response => {
                    if (!response.ok) {

                        return;
                    }
                    
                    this.setState({
                        permissions: response.data.entities,
                    });
                });
            }
        }
    }

    transformRequest(data) {
        return {
            ...data,
            userEmail: this.props.uemail,
            companyId: this.props.cid,
            roleId: this.state.data.role ? this.state.data.role.id : null,
            permissionId: this.state.data.permission ? this.state.data.permission.id : null,

        }
    }

    submit(){
        
        if(!this.validate()){
            
            return;
        }

        this.showDrawerLoader();
    

        addRolePermissions(this.transformRequest(this.state.data), this.props.cid).then(response =>{
            if(!response.ok){
                let messageKey = response.response.data.message;

                this.props.enqueueSnackbar(strings.state.messages[messageKey], {
                    variant: "error"
                });

                // this.handleError(messageKey);

                return;
            }
            this.props.enqueueSnackbar(strings.rolePermission.addRolePermission, { variant: 'success' });
            this.props.onFinish(response.data.state);

            this.hideDrawerLoader();
        
        })
    }

    render() {
        return (
            <Grid id='page' item md={12}>

            <div className='header'>
                <h1>{"Дозволе рола"}</h1>
            </div>

            <Paper className='paper'>
                <RolePermissionForm 
                onChange={this.changeData} 
                cid={this.state.companyId} 
                onSubmit={this.submit} data={this.state.data} 
                data1={this.state.data}
                onCancel={this.props.onCancel}
                isDisabled={this.props.isDIsabled}
                onAutocompleteChange={this.onAutocompleteChange}
                handleTextInputChange={this.handleTextInputChange}
                roles={this.state.roles == undefined ? [] : this.state.roles}
                permissions={this.state.permissions == undefined ? [] : this.state.permissions}/>
            </Paper>

        </Grid>
        );
    }

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeFullScreen: Actions.changeFullScreen
    }, dispatch);
}

function mapStateToProps({ menuReducers, siteDataReducers }) {
    return { menu: menuReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(AddRolePermissions)));